import { render, staticRenderFns } from "./ANZGROUPHEADLINE.vue?vue&type=template&id=0aa35a06"
import script from "./ANZGROUPHEADLINE.vue?vue&type=script&lang=js"
export * from "./ANZGROUPHEADLINE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports